import React from "react"
import { getCurrentYear } from "../../../../selectors/getType"

export default function FooterMeta({ data }) {
  return (
    <div className="cic-footer-secondary-container">
      <div className="secondary-item">
        <img
          alt={`${process.env.GATSBY_BRAND}! Your One Stop Money Shop`}
          title={`${process.env.GATSBY_BRAND}! Your One Stop Money Shop`}
          className=""
          width={240}
          src={data.footer_logo__footer_logo.value[0].url}
        />
        <div>
          <p className="cic-caption mb-2">
            © {getCurrentYear()} {process.env.GATSBY_BRAND},{" "}
            {data.footer_logo__footer_small_legal.value}
          </p>
        </div>
      </div>
      <div className="secondary-item">
        <a
          className="btn-header cic-btn-icon cic-caption--medium btn-footer-secondary"
          title="Click here to find a California Check Cashing store near you"
          aria-label="Click here to find a California Check Cashing store near you"
          href="/store-locator/"
        >
          <img
            className="target-icon"
            src="https://assets-us-01.kc-usercontent.com/4f626d0e-ea43-0058-7ee6-030359e555db/4336d85b-080a-474d-b2a7-c8839752905c/map-marker.svg"
            alt="Target Icon"
          />
          <span className="cic-caption--bold-header ">Find a Store</span>
        </a>
      </div>
      <div className="secondary-item">
        <a
          href="https://onlinelendersalliance.org/consumer-resources/look-for-the-ola-seal/"
          target="_blank"
          rel="noopener noreferrer"
          arial-label="Click here to read more about OLA Seal & Hotline"
        >
          <img
            src="https://assets-us-01.kc-usercontent.com/4f626d0e-ea43-0058-7ee6-030359e555db/e7f1a795-df3e-44ce-9110-a0345e7a61e8/ola-logo.png"
            width={120}
            alt="Proud Member Ola - Logo"
          />
        </a>
        {/* <img 
                src='https://assets-us-01.kc-usercontent.com/4f626d0e-ea43-0058-7ee6-030359e555db/ae2cc5f7-9b81-4c8f-8bbb-00d8cfdea72b/infin-logo.png' 
                width={160}
                alt="INFIN - A Financial Services Alliance - Logo"
            /> */}
      </div>
    </div>
  )
}
